import { createFileRoute } from "@tanstack/react-router";
import { LoginForm } from "@/auth/LoginForm";
import { ErrorComponent } from "@/components/Error";

export const Route = createFileRoute("/(unauthed)/_layout/login")({
  component: LoginForm,
  errorComponent: (props) => (
    <ErrorComponent title="Login Error" message="There was a problem loading the login page." {...props} />
  ),
});
